import BaseHeading from '@tiptap/extension-heading';
import { textblockTypeInputRule } from '@tiptap/react';

export const Heading = BaseHeading.extend({
  marks: '',

  parseHTML() {
    return [1, 2, 3, 4, 5, 6].map(level => ({
      tag: `h${level}`,
      attrs: { level: 2 }
    }));
  },

  addKeyboardShortcuts() {
    return [1, 2, 3, 4, 5, 6].reduce(
      (items, level) => ({
        ...items,
        [`Mod-Alt-${level}`]: () => this.editor.commands.toggleHeading({ level: 2 })
      }),
      {}
    );
  },

  addInputRules() {
    return [1, 2, 3, 4, 5, 6].map(level => {
      return textblockTypeInputRule({
        find: new RegExp(`^(#{1,${level}})\\s$`),
        type: this.type,
        getAttributes: {
          level: 2
        }
      });
    });
  }
}).configure({
  levels: [2]
});
